import React from 'react';
import { Container } from './ui/Container';
import { quickBenefits } from '../data/sections';
export function BenefitsStrip() {
  return <section className="border-y border-mp-border bg-mp-dark py-10 md:py-12" data-id="element-38" data-mp="3sqv5hvua7zfo">
      <Container data-id="element-39" data-mp="b9byqeht1v2f">
        <div className="grid grid-cols-2 gap-6 md:grid-cols-4 md:gap-8" data-id="element-40" data-mp="b9v5cz208x15">
          {quickBenefits.map(item => <div key={item.title} className="text-center md:text-left" data-id="element-41" data-mp="6fr0clcauz2p">
              <p className="font-heading text-xl uppercase tracking-wide text-mp-lime sm:text-2xl" data-id="element-42" data-mp="k7nka23te2o0">{item.title}</p>
              <p className="mt-1 text-xs text-mp-gray sm:text-sm" data-id="element-43" data-mp="g7dd4m4ad67k">{item.copy}</p>
            </div>)}
        </div>
      </Container>
    </section>;
}